import React, { useState, useEffect, useRef, useMemo } from 'react';
import { Link } from 'react-router-dom';
import back_arrow from "../img/back_arrow.png";


const TitleBackButton = ({title}) => {

        return         <div className="back-title">
          <Link to={"/home"}>
            <button className="back-button">
              <img alt="back" src={back_arrow} />

              <div className="back-button-text">Torna indietro</div>
            </button>
          </Link>
          <div className="title">
            {title}
          </div>
        </div>

}



export default TitleBackButton;
